// extracted by mini-css-extract-plugin
export default {"container":"YouTube_container__wZ5LB","iframe":"YouTube_iframe__HPhHM"};